import { render, staticRenderFns } from "./Adjustment.vue?vue&type=template&id=084c2238&"
import script from "./Adjustment.vue?vue&type=script&lang=js&"
export * from "./Adjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports